
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import LIST_COMPANIES from "@/apollo/autocomplete-queries/GetUserCompanies.gql";

  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootCompanyArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      companies: {
        query: LIST_COMPANIES,
        variables() {
          return this.companyAutocompleteFilter;
        },
        update(data) {
          return data.company;
        },
        skip() {
          return !this.companySearchString;
        },
      },
    },
  })

  export default class ContractorCompaniesMultiselect extends Vue {
    @Prop({ required: true, type: Array }) value!: DropdownOption[];
    @Prop({ required: true, type: String }) currentUserId!: string;
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
    @Prop({ default: "Select company", type: String }) readonly placeholder!: string;

    companies: DropdownOption[] = [];

    companySearchString = "";

    get mappedCompaniesValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get companyAutocompleteFilter(): Query_RootCompanyArgs {
      const conditions: any[] = [
        { business_name: { _ilike: `%${this.companySearchString}%`}},
        { contractors: {
          user_id: { _eq: this.currentUserId },
        }},
      ];
      if (this.mappedCompaniesValue.length) {
        conditions.push({ business_name: {
          _nin: this.mappedCompaniesValue,
        }});
      }

      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
